var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.75 4.99918C19.75 5.19809 19.671 5.38885 19.5303 5.52951C19.3897 5.67016 19.1989 5.74918 19 5.74918L2.81 5.74918L5.28 8.21918C5.35369 8.28784 5.41279 8.37064 5.45378 8.46264C5.49477 8.55464 5.51681 8.65395 5.51859 8.75465C5.52037 8.85536 5.50184 8.95538 5.46412 9.04877C5.4264 9.14216 5.37026 9.227 5.29904 9.29821C5.22782 9.36943 5.14298 9.42558 5.0496 9.4633C4.95621 9.50102 4.85618 9.51954 4.75548 9.51777C4.65477 9.51599 4.55546 9.49395 4.46346 9.45296C4.37146 9.41197 4.28866 9.35286 4.22 9.27918L0.469999 5.52918C0.32955 5.38855 0.25066 5.19793 0.25066 4.99918C0.25066 4.80043 0.32955 4.6098 0.469999 4.46918L4.22 0.719176C4.28866 0.645489 4.37146 0.586387 4.46346 0.545395C4.55546 0.504403 4.65477 0.482362 4.75548 0.480585C4.85618 0.478808 4.95621 0.497332 5.0496 0.535053C5.14299 0.572774 5.22782 0.628919 5.29904 0.700138C5.37026 0.771357 5.4264 0.85619 5.46412 0.949579C5.50184 1.04297 5.52037 1.143 5.51859 1.2437C5.51681 1.3444 5.49477 1.44372 5.45378 1.53571C5.41279 1.62771 5.35369 1.71051 5.28 1.77918L2.81 4.24918L19 4.24918C19.1989 4.24918 19.3897 4.3282 19.5303 4.46885C19.671 4.6095 19.75 4.80026 19.75 4.99918Z",
    fill: "#515151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.1cd7e011760ef5f9c0d6a76aef0475f9.svg";
export { ForwardRef as ReactComponent };